/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import CustomDialog from '@app/components/molecules/CustomDialog';
import { initialData } from '@app/config/initial-data';
import { APPLICATION_DETAILS } from '@app/pages/applications/view';
import {
  USER_SUBMISSION_APPLICATIONS,
  GET_APPLICATIONS_FILTER,
  SUBMISSION_APPLICATION_FORM,
} from '@app/apollo/queries';
import MaterialTable, { MTableToolbar } from 'material-table';
import Typography from '@app/components/atoms/Typography';
import { Grid, Select, MenuItem, Checkbox, ListItemText, FormControl } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import BorderButton from '@app/components/atoms/BorderButton';
import Spacer from '@app/components/atoms/Spacer';
import { useUser } from '@app/contexts/userContext';
import { useTranslation } from '@app/config/i18n';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { FIELDS_ENUM } from '@app/constants';
import OpportunityFormViewer from '../../OpportunityFormViewer';
import SectionSkeleton from '../../OpportunityFormViewer/FormBody/skeleton';
import { MaterialTableContainer, StyledTitle } from './style';

const UserSubmissionApplicationsPage = ({
  opportunity,
  showApplicationForm,
  setShowApplicationForm,
  columns,
  tableCols,
  handleToggleColumn,
}) => {
  const { t } = useTranslation(['common']);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { user } = useUser();
  const [pageSize, setPageSize] = useState(100);
  const [page, setPage] = useState(1);
  const [menuEl, setMenuEl] = useState(null);
  const isMenuOpen = Boolean(menuEl);
  const availableColumns = columns || [];

  const [selectedSubmission, setSelectedSubmission] = useState({});

  const { data: { submissionApplicationForm } = {}, loading: submissionApplicationFormLoading } =
    useQuery(SUBMISSION_APPLICATION_FORM, {
      variables: {
        slug: opportunity.slug,
      },
    });

  const {
    loading: applicationLoading,
    data: { viewSubmissionApplication } = {},
    refetch: viewSubmissionApplicationRefetch,
  } = useQuery(APPLICATION_DETAILS, {
    variables: {
      id: selectedSubmission?.id,
    },
    skip: !selectedSubmission || Object.keys(selectedSubmission).length === 0,
  });

  const [initialValue, setInitialValue] = useState({
    opportunity: opportunity.slug,
    track: null,
    fields: {},
    members: [],
    recaptcha: null,
  });

  const [showTerms, setShowTerms] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);

  const { data: { applicationFilters = initialData.applicationFilters } = {}, client } =
    useQuery(GET_APPLICATIONS_FILTER);

  const {
    loading: userSubmissionApplicationsLoading,
    data: { userSubmissionApplications } = {},
    refetch,
  } = useQuery(USER_SUBMISSION_APPLICATIONS, {
    variables: {
      slug: opportunity.slug,
      filters: applicationFilters.filters,
      first: pageSize,
      page,
    },
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!userSubmissionApplicationsLoading && userSubmissionApplications?.data?.length === 0) {
      setShowApplicationForm(true);
    }
  }, [userSubmissionApplicationsLoading, userSubmissionApplications, setShowApplicationForm]);

  const updateFilters = (filters) => {
    client.writeQuery({
      query: GET_APPLICATIONS_FILTER,
      data: { applicationFilters: { ...filters } },
    });
  };

  const onChangePage = (next) => {
    const { first, filters } = applicationFilters;
    updateFilters({
      filters,
      page: next + 1,
      first,
    });
  };



  const handleMenuColumnButtonClick = () => {
    setMenuEl(true);
  };

  const handleColumnMenuClose = () => {
    setMenuEl(null);
  };

  const editApplicationHandler = (data) => {
    setSelectedSubmission(data);
  };
  const tableActions = [
    (rowData) => ({
      tooltip: t('common:Edit selected submissions'),
      icon: 'edit',
      onClick: () => editApplicationHandler(rowData),
    }),
  ];

  useEffect(() => {
    if (selectedSubmission && Object.keys(selectedSubmission).length > 0) {
      viewSubmissionApplicationRefetch({
        id: selectedSubmission.id,
      });
    }
  }, [selectedSubmission, viewSubmissionApplicationRefetch]);

  useEffect(() => {
    if (viewSubmissionApplication && Object.keys(viewSubmissionApplication).length > 0) {
      const updatedFields = {};
      let updatedMembers = [];

      viewSubmissionApplication.elements?.forEach((element) => {
        if (
          element.type === FIELDS_ENUM.MANDATORY_AUTHORS &&
          element.child_elements &&
          element.child_elements?.length > 0
        ) {
          updatedMembers = element.child_elements.map((childArray, groupIdx) =>
            childArray?.map((fieldElem) => ({
              field: fieldElem.field_id,
              value: fieldElem.value,
              group_idx: groupIdx,
            }))
          );
        }
        if(element.type === FIELDS_ENUM.PAPER || element.type === FIELDS_ENUM.KEYWORDS) {
          updatedFields[element.field_id] = element.value.split(',');
        } else  if (!element.value && element.files && element.files.length > 0) {
          updatedFields[element.field_id] = element.files;
        } else {
          updatedFields[element.field_id] = element.value;
        }
      });

      setInitialValue((prev) => ({
        ...prev,
        opportunity: selectedSubmission.opportunity.slug,
        fields: updatedFields,
        members: updatedMembers,
        track: viewSubmissionApplication?.track && {
          id: viewSubmissionApplication.track.id,
          track_name: viewSubmissionApplication.track.track_name,
        },
      }));
    }
  }, [viewSubmissionApplication, selectedSubmission]);

  const handleCloseModal = () => {
    setSelectedSubmission({});
    setInitialValue((prev) => ({
        ...prev,
        fields: {},
        members: [],
    }));
  };


  return (
    <>
      {!isMobile && <Spacer height="6rem" />}
      {!isMobile && (
        <StyledTitle>
          <Typography color="secondary" variant="h5">
            {t('common:submissions')}
          </Typography>
        </StyledTitle>
      )}
      {!user ? (
        <>
          <Spacer height="2rem" />
          <Grid container justifyContent="center">
            <Typography variant="body1" color="tan">
              {t('common:log_for_sub')}
            </Typography>
          </Grid>
        </>
      ) : (
        !!userSubmissionApplications?.data?.length &&
          <>
            <MaterialTableContainer>
              <MaterialTable
                onChangePage={onChangePage}
                options={{
                  paging: userSubmissionApplications
                    ? userSubmissionApplications.data.length >= 10
                    : false,
                  search: false,
                  showTitle: false,
                  toolbar: !isMobile,
                  sorting: false,
                  draggable: false,
                  showSelectAllCheckbox: false,
                  pageSize,
                  pageSizeOptions: [10, 25, 50],
                  paginationType: 'stepped',
                  cellStyle: {
                    whiteSpace: 'nowrap',
                  },
                  headerStyle: {
                    fontWeight: 600,
                  },
                  actionsColumnIndex: -1,
                }}
                actions={tableActions}
                columns={tableCols}
                data={(query) =>
                  new Promise((resolve, reject) => {
                    setPageSize(query.pageSize);
                    setPage(query.page);
                    refetch({
                      slug: opportunity.slug,
                      filters: applicationFilters.filters,
                      first: query.pageSize,
                      page: query.page + 1,
                    })
                      .then((result) => {
                        resolve({
                          data:
                            result?.data?.userSubmissionApplications?.data?.length > 0
                              ? result.data.userSubmissionApplications.data.map((app) => ({ ...app }))
                              : [],
                          page:
                            result?.data?.userSubmissionApplications?.paginatorInfo.currentPage - 1,
                          totalCount: result?.data?.userSubmissionApplications?.paginatorInfo.total,
                        });
                      })
                      .catch((error) => {
                        reject(error);
                      });
                  })
                }
                components={{
                  Toolbar: (props) => (
                    <div>
                      <MTableToolbar {...props} />
                      <Grid container spacing={2} marginBottom={2}>
                        <Grid item xs={6} md={3}>
                          <FormControl sx={{ width: '100%' }}>
                            <Select
                              id="columns-selection-button"
                              value=""
                              displayEmpty
                              renderValue={() => t('common:Select Columns')}
                              fullWidth
                              open={isMenuOpen}
                              onOpen={handleMenuColumnButtonClick}
                              onClose={handleColumnMenuClose}
                              MenuProps={{
                                anchorOrigin: {
                                  vertical: 'bottom',
                                  horizontal: 'left',
                                },
                                transformOrigin: {
                                  vertical: 'top',
                                  horizontal: 'left',
                                },
                              }}
                            >
                              {availableColumns.map((col) => (
                                <MenuItem key={col.id}>
                                  <Checkbox
                                    value={col.id}
                                    checked={col.isVisible}
                                    onChange={() => handleToggleColumn(col.id)}
                                  />
                                  <ListItemText primary={col.label} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </div>
                  ),
                }}
              />
            </MaterialTableContainer>
            {userSubmissionApplications?.data?.length > 0 ? (
              <BorderButton
                id="add-video"
                variant="text"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => setShowApplicationForm(true)}
              >
                <Typography>Add another submission</Typography>
              </BorderButton>
            ) : (
              <Spacer height="1rem" />
            )}
          </>
      )}

      <CustomDialog
        open={Object.keys(selectedSubmission)?.length > 0}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        {applicationLoading ? (
          <>
            {Array.from(new Array(6)).map((e, i) => (
              <Grid item sm={12} key={i}>
                <SectionSkeleton />
              </Grid>
            ))}
          </>
        ) : (
          <OpportunityFormViewer
            myOpportunity={opportunity}
            opportunitySlug={opportunity.slug}
            applicationId={selectedSubmission.id}
            applicationForm={submissionApplicationForm}
            loading={submissionApplicationFormLoading}
            initialValue={initialValue}
            setInitialValue={setInitialValue}
            handleCloseModal={handleCloseModal}
            showTerms={showTerms}
            setShowTerms={setShowTerms}
            agreeTerms={agreeTerms}
            setAgreeTerms={setAgreeTerms}
            showApplicationForm={showApplicationForm}
            setShowApplicationForm={setShowApplicationForm}
            editMode
          />
        )}
      </CustomDialog>
    </>
  );
};

UserSubmissionApplicationsPage.propTypes = {
  opportunity: PropTypes.object.isRequired,
  showApplicationForm: PropTypes.bool,
  setShowApplicationForm: PropTypes.func,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      isVisible: PropTypes.bool,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    })
  ),
  tableCols: PropTypes.array,
  handleToggleColumn: PropTypes.func,
};

UserSubmissionApplicationsPage.defaultProps = {
  showApplicationForm: false,
  setShowApplicationForm: () => {},
  columns: [],
  tableCols: [],
  handleToggleColumn: () => {},
};

export default UserSubmissionApplicationsPage;
